import { render, staticRenderFns } from "./classes-question.vue?vue&type=template&id=fcba1214&scoped=true"
import script from "./classes-question.vue?vue&type=script&lang=js"
export * from "./classes-question.vue?vue&type=script&lang=js"
import style0 from "./classes-question.vue?vue&type=style&index=0&id=fcba1214&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcba1214",
  null
  
)

export default component.exports